export default __webpack_public_path__ + "static/media/icon_padlock.aa5163d1.svg";